import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function AuthCallback() {
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('invite') || searchParams.get('state') // Check both invite param and state (from SSO)
  const hasProcessed = useRef(false)

  useEffect(() => {
    // Prevent duplicate processing
    if (hasProcessed.current) return
    hasProcessed.current = true

    const handleCallback = async () => {
      // Check if token is directly in URL (from WorkOS callback)
      const token = searchParams.get('token')
      if (token) {
        localStorage.setItem('auth_token', token)
        window.location.href = '/dashboard'
        return
      }

      // Otherwise, handle OAuth code exchange
      const code = searchParams.get('code')
      const state = searchParams.get('state')

      if (code) {
        try {
          // Exchange code for token with your API
          const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/v1/auth/sso/callback`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              code,
              state
            })
          })

          if (response.ok) {
            const data = await response.json()
            localStorage.setItem('auth_token', data.token)
            
            // If there's an invitation, accept it automatically
            if (inviteToken) {
              try {
                const acceptResponse = await fetch(
                  `${import.meta.env.VITE_API_BASE_URL}/v1/invitations/${inviteToken}/accept`,
                  {
                    method: 'POST',
                    headers: {
                      'Authorization': `Bearer ${data.token}`
                    }
                  }
                )

                if (acceptResponse.ok) {
                  // Successful authentication and invitation acceptance
                  window.location.href = '/dashboard?invitation_accepted=true'
                  return
                } else {
                  // Authentication succeeded but invitation failed
                  console.error('Failed to accept invitation after SSO auth')
                  window.location.href = '/dashboard?invite_error=true'
                  return
                }
              } catch (inviteErr) {
                console.error('Error accepting invitation after SSO auth:', inviteErr)
                window.location.href = '/dashboard?invite_error=true'
                return
              }
            }
            
            // No invitation - proceed normally
            if (data.needsOnboarding) {
              window.location.href = '/onboarding'
            } else {
              window.location.href = '/dashboard'
            }
          } else {
            throw new Error('Authentication failed')
          }
        } catch (error) {
          console.error('SSO callback failed:', error)
          window.location.href = '/login?error=sso_failed'
        }
      } else {
        window.location.href = '/login?error=no_code'
      }
    }

    handleCallback()
  }, []) // Remove searchParams from dependencies to prevent re-runs

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  )
}